export enum Chat_Message_Custom_Type {
  OFFER = 'OFFER',
  ACCEPTED_OFFER = 'ACCEPTED_OFFER',
  JOINED = 'JOINED',
  CREATED = 'CREATED',
  LEFT = 'LEFT',
  INVITED = 'INVITED',
  SUPPLIER_INFO = 'SUPPLIER_INFO',
}
